import { SearchOutlined } from '@ant-design/icons'
import styled from '@emotion/styled'
import CommonButton from '@/components/common/Button'
import { Input } from 'antd'

export const Container = styled('div')`
  margin: 24px auto;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 24px 32px;
  width: 100%;
  position: relative;
  user-select: none;
`

export const SearchInput = styled(Input)`
  width: 320px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  margin-bottom: 24px;
`

export const SearchIcon = styled(SearchOutlined)`
  color: #adadad;
`

export const HeaderWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
`

export const Button = styled(CommonButton)`
  line-height: 20px;
  padding: 10px 16px;
  width: 161px;
`

export const IconSvg = styled('img')`
  margin-right: 10px;
  height: 15px;
  width: 15px;
`

export const DeleteIcon = styled('img')`
  height: 20px;
  width: 20px;
  cursor: pointer;
`
